var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page-top",attrs:{"id":"page"}},[_c(_setup.HeaderView),_c(_setup.ContentView),_c(_setup.FooterView)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }